import React, { useEffect, useRef, useState } from "react";
import { Grid } from "@mui/material";
import { FormButton, SpinnerOverlay } from "components";
import {
  FormikSelectInput,
  FormikTextInput,
} from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { LARGO, mensajeLargo } from "consts/limites-campos";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { RNHFuncionIns } from "services/services-mia/programa-salud/personal/RNHFuncionIns";
import { RNHAgrupamientoGet } from "services/services-mia/programa-salud/personal/RNHAgrupamientoGet";

export default function InsertModal({ updateList, closeModal }) {
  const setSnackBarInfo = useSetRecoilState(snackbarData);
  const [inRequest, setInRequest] = useState(false);
  const credentials = useRecoilValue(userCredentials);
  const formikRef = useRef();

  const [agrupamientos, setAgrupamientos] = useState([]);
  const [cargandoAgrupamientos, setCargandoAgrupamientos] = useState(true);

  useEffect(() => {
    (async () => {
      const { data: result } = await RNHAgrupamientoGet(credentials);
      // Sin esto el select lista la fila centinela del back como si fuera una opcion.
      setAgrupamientos(result?.[0]?.rnhAgrupamientoId ? result : []);
      setCargandoAgrupamientos(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const crearFuncion = async (values) => {
    setInRequest(true);
    const response = await RNHFuncionIns(credentials, {
      nombre: values.nombre,
      cod: values.cod,
      agrupamientoId: values.agrupamientoId,
    });
    setInRequest(false);
    if (response.ok) {
      setSnackBarInfo({
        message: "Función creada correctamente",
        severity: "success",
        open: true,
      });
      formikRef.current.resetForm();
      updateList();
      closeModal();
    }
  };

  return (
    <Formik
      innerRef={formikRef}
      initialValues={{
        nombre: "",
        cod: "",
        agrupamientoId: "",
      }}
      validationSchema={yup.object({
        nombre: yup
          .string()
          .max(LARGO.nombre, mensajeLargo(LARGO.nombre))
          .required("Debe ingresar un nombre"),
        cod: yup
          .string()
          .max(LARGO.cod, mensajeLargo(LARGO.cod))
          .required("Debe ingresar un código"),
        // Es string: el <select> entrega strings y el id se convierte en el servicio.
        agrupamientoId: yup.string(),
      })}
      onSubmit={(values) => {
        crearFuncion(values);
      }}
    >
      <Form className={styles.inputs} noValidate>
        <div className={styles["column"]}>
          <Grid
            container
            rowSpacing={0}
            columnSpacing={2}
            sx={{
              width: "100%",
              "& .MuiFormControl-root": { marginTop: 0, marginBottom: 0 },
            }}
          >
            <Grid item xs={4}>
              <FormikTextInput
                fullWidth={true}
                name="cod"
                labelText="Código"
                  inputProps={{ maxLength: LARGO.cod }}
              />
            </Grid>
            <Grid item xs={8}>
              <FormikTextInput
                fullWidth={true}
                name="nombre"
                labelText="Nombre"
                  inputProps={{ maxLength: LARGO.nombre }}
              />
            </Grid>
            <Grid item xs={12}>
              {/* No es obligatorio: una funcion puede no pertenecer a ningun
                  agrupamiento. Por eso la opcion vacia NO va `disabled` como en otros
                  selects del modulo: tiene que poder elegirse para dejarlo sin
                  agrupamiento, y tambien para sacarle el que ya tenia. */}
              <FormikSelectInput
                name="agrupamientoId"
                labelText="Agrupamiento"
                disabled={cargandoAgrupamientos}
              >
                <option value="">Sin agrupamiento</option>
                {agrupamientos.map((a) => (
                  <option key={a.rnhAgrupamientoId} value={a.rnhAgrupamientoId}>
                    {a.rnhAgrupamientoNombre}
                  </option>
                ))}
              </FormikSelectInput>
            </Grid>
          </Grid>
          <FormButton
            inRequest={inRequest}
            newFormData={{ button: "Crear" }}
            onCloseModal={closeModal}
          />
          {(inRequest) && <SpinnerOverlay />}
        </div>
      </Form>
    </Formik>
  );
}
